import { CalculatorsRequest } from "../models/calculators.models";

// Mirrors the PBIP slicer defaults independently of either live or modeled response data.
export const initialCalculatorsRequest: CalculatorsRequest = {
  draft: {
    vesselType: "Capes (incl. Newcs)",
    condition: "Ballast",
    speedExponent: 2.8,
    normalizationDraft: 14,
    stw: 11.5,
    meConsumption: 20.7,
    aeConsumption: 2,
    draft: 11.5,
  },
  fuelCurve: {
    speedExponent: 2.8,
    laden: { referenceSpeed: 11, meConsumption: 15, aeConsumption: 2 },
    ballast: { referenceSpeed: 15, meConsumption: 15, aeConsumption: 3 },
  },
  performance: {
    rows: ["ballastEco", "ladenEco", "ballastFull", "ladenFull"].map((kind) => ({
      kind: kind as "ballastEco" | "ladenEco" | "ballastFull" | "ladenFull",
      expectedSpeed: null,
      expectedConsumption: null,
      cpSpeed: null,
      cpConsumption: null,
    })),
  },
};
